<div class="space-y-2">
  <div class="border border-gray-400 overflow-hidden" style="height: 210px; width: 100%;">
    <video autoplay loop muted playsinline width="100%" height="auto" class="object-contain">
      <source src="/videos/pick-dim.mp4" type="video/mp4" />
    </video>
  </div>
  <div>
    If you are unable to find a scale, you can pick a dimension on the page to measure. Click "Pick a
    dimension", then click both ends of a clearly-marked dimension to define the page scale.
  </div>
</div>
